module.exports = __webpack_public_path__ + "static/media/honor4.5af289d4.jpg";